/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"
/* Services */

const AboutDeviSlide14 = ({ section }) => {
  return (
    <Box
      background={`#000 url(${config.imgPath}/d/46272/1684474743-ib_secion14bg.jpg) no-repeat center center`}
      bgSize={{ base: '70rem', lg: 'cover' }}
      bgColor="#000"
      className={styles.section14Bg}
    >
      <Box
        maxW="1200px"
        mx="auto"
        height="100%"
        display="flex"
        position="relative"
        alignItems="center"
        justifyContent="center"
        flexDir={{ base: 'column', lg: 'row' }}
        minH="100vh"
      >
        <Box
          maxW={{ base: '280px', md: '390px' }}
          w="100%"
          textAlign="center"
          px={{ base: '16px', md: '10px' }}
        >
          <Text color="#D09700" fontSize={{ base: '18px', lg: '24px' }}>
            As he roared, stillness made way for creation. So, though Shiva is seen as the basis of creation, the first act of creation was Devi’s.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide14;
